import { connect } from 'react-redux';

import { starredBoardgamesSelector } from '../reducers/boardgames';

import BoardgamesSelectionHeroComponent from '../components/BoardgamesSelectionHero';

const mapStateToProps = (state) => {
  return {
    boardgames: starredBoardgamesSelector(state),
  };
};

const BoardgamesSelectionHero = connect(mapStateToProps)(BoardgamesSelectionHeroComponent);

export default BoardgamesSelectionHero;
